import { render, staticRenderFns } from "./PromoCodeListTable.vue?vue&type=template&id=06530760&scoped=true&"
import script from "./PromoCodeListTable.vue?vue&type=script&lang=js&"
export * from "./PromoCodeListTable.vue?vue&type=script&lang=js&"
import style0 from "./PromoCodeListTable.vue?vue&type=style&index=0&id=06530760&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06530760",
  null
  
)

export default component.exports